import { EditIcon, TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons'
import { Box, Center, chakra, Flex, Grid, Heading, Menu, MenuButton, MenuItem, MenuList, ScaleFade, Table, Tbody, Td, Text, Tfoot, Th, Thead, Tr, useColorModeValue, useDisclosure } from '@chakra-ui/react'
import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { DataContext } from '../../../../state/DataContext/DataContext'
import { JobInfoPage } from '../JobInfoPage/JobInfoPage'
import { JobCard } from '../JobCard/JobCard'
import { useSortBy, useTable } from 'react-table'
import { useCollection } from 'react-firebase-hooks/firestore';
import { firestore } from '../../../../utils/firebase'
import EditJobBtn from '../JobForm/EditJob/EditJobBtn';
import { capitalizeFirstLetter } from '../../../../utils/formatter'
import { DeleteJobBtn } from '../DeleteJobBtn/DeleteJobBtn'
import { detectMob } from './../../../../utils/mobile';
import { AddJobBtn } from '../JobForm/AddJob/AddJobBtn'
import { Spinner } from '@chakra-ui/react';

export default function JobBoard() {
    const gray = useColorModeValue("gray.600", "gray.400");

    const { data, actions } = React.useContext(DataContext);
    const { tenantID, JobID } = useParams<any>();

    const [dataArray, setDataArray] = React.useState([]);

    const [value, loading, error] = useCollection(
        firestore.collection(`tenants/${tenantID}/jobs`).where("TenantID", "==", tenantID),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );

    React.useEffect(() => {
        const tempDataArray = [] as any;

        value?.docs.forEach((doc) => {
            let job = doc.data();
            tempDataArray.push(
                {
                    Title: capitalizeFirstLetter(job.Title),
                    StartDate: new Date(job.StartDateTime.toDate()).toLocaleDateString(),
                    StartDateTime: new Date(job.StartDateTime.toDate()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                    EndDateTime: new Date(job.EndDateTime.toDate()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                    CustomerName: capitalizeFirstLetter(job.CustomerName),
                    // Status: job.Status,
                    Address: job.Address,
                    ID: job.ID,
                    Job: job,
                    NumberOfTasks: "0",
                    // AssignedTo: JSON.stringify(job.AssignedTo)
                })
        })
        setDataArray(tempDataArray);
    }, [value])

    const setJob = (job) => {
        actions.Job.SetCurrentJob(job);
    }

    const columns = React.useMemo(
        () => [
            {
                Header: "Job",
                accessor: "Title",
            },
            {
                Header: "Start Date",
                accessor: "StartDate",
            },
            {
                Header: "Start Time",
                accessor: "StartDateTime",
            },
            {
                Header: "End Time",
                accessor: "EndDateTime",
            },
            {
                Header: "Customer Name",
                accessor: "CustomerName",
            },
            {
                Header: "# of Tasks",
                accessor: "NumberOfTasks",
            }
        ], [],
    )

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data: dataArray }, useSortBy);

    const DataTable = () => {

        return (
            <>
                <Table
                    variant="simple"
                    {...getTableProps()}
                    size="sm"
                    bg="white"
                    borderRadius="lg"
                    boxShadow="md"
                >
                    <Thead>
                        {headerGroups.map((headerGroup, index) => (
                            <Tr key={`header-${index}`} {...headerGroup.getHeaderGroupProps()} >
                                <Th textAlign="center">Actions</Th>
                                {headerGroup.headers.map((column, index) => (
                                    <Th
                                        key={`column-${index}`}
                                        textAlign="center"
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                        isNumeric={column.isNumeric}>

                                        {column.render("Header")}

                                        <chakra.span pl="2" fontSize="0.8em">
                                            {column.isSorted ? (
                                                column.isSortedDesc ? (
                                                    <TriangleDownIcon aria-label="sorted descending" />
                                                ) : (
                                                    <TriangleUpIcon aria-label="sorted ascending" />
                                                )
                                            ) : null}
                                        </chakra.span>

                                    </Th>
                                ))}
                                <Th textAlign="center">Assigned To</Th>
                            </Tr>
                        ))}
                    </Thead>

                    <Tbody {...getTableBodyProps()}>
                        {rows.map((row, index) => {
                            prepareRow(row)
                            return (
                                <Tr key={`row-${row.original.ID}`} {...row.getRowProps()}>
                                    <Td borderBottom="none" borderTop="0.5px solid #EDF2F7" >
                                        <Menu>
                                            <MenuButton as={Text} textAlign="center" cursor="pointer">
                                                <EditIcon />
                                            </MenuButton>
                                            <MenuList >
                                                <Link to={`/${tenantID}/admin/jobs/${row.original.ID}`}> <MenuItem onClick={() => setJob(row.original.Job)}>Edit Checklist</MenuItem>
                                                </Link>
                                                <EditJobBtn job={row.original.Job}
                                                    renderBtn={() => {
                                                        return <MenuItem>
                                                            <EditIcon mr="2" />
                                                            Edit Job</MenuItem>
                                                    }} />
                                                <DeleteJobBtn
                                                    TenantID={tenantID}
                                                    JobID={row.original.ID}

                                                />
                                            </MenuList>
                                        </Menu>
                                    </Td>
                                    {row.cells.map((cell, index) => (
                                        <Td key={`${index}-${row.original.ID}`} borderBottom="none" borderTop="0.5px solid #EDF2F7"   {...cell.getCellProps()} isNumeric={cell.column.isNumeric} textAlign="center">
                                            {cell.render("Cell")}
                                        </Td>
                                    ))}
                                    <Td borderBottom="none" borderTop="0.5px solid #EDF2F7" >
                                        {(row.original.AssignedTo && JSON.parse(row.original.AssignedTo).map((assignedTo, index) => {
                                            return <span key={`comma-${index}`}>{(assignedTo?.Name + (JSON.parse(row.original.AssignedTo).length !== (index) && ",")
                                            )}</span>
                                        }))}
                                    </Td>
                                </Tr>
                            )
                        })}
                    </Tbody>
                    <Tfoot>
                        <Tr>
                            <Th></Th>
                        </Tr>
                    </Tfoot>
                </Table>
                {
                    rows.length === 0 && <Center height="60vh">
                        <Box textAlign="center" mt="4">
                            <Text>You dont have any jobs yet. </Text>
                        </Box>
                    </Center>
                }
            </>
        )
    }

    const MobileView = () => {
        return <Box width="100%">
            <Heading px={4} py={4} color={gray}
                size="md" textTransform="capitalize">
                Job List
            </Heading>
            <Flex
                justifyContent="center"
                maxW={{ xl: "1200px" }}
                m="0 auto"
            >
                <Grid
                    w="full"
                    gridGap="5"
                    gridTemplateColumns={{ base: "100%", 'md': "repeat( auto-fit, 45% )" }}
                >
                    {dataArray.map((job: any, index) => {
                        return <JobCard key={`JobCard-${index}`} id={job.ID} job={job.Job} link={job.ID} status="green" />
                    })}
                </Grid>
            </Flex>
        </Box>
    }


    return (
        <>
            { }
            <ScaleFade hidden={JobID !== "all"} key="All-Jobs" initialScale={0.9} in={JobID === "all"} >
                {loading ? <Center height="80vh"><Spinner /></Center> :
                    <Box>
                        <AddJobBtn />
                        {detectMob() ? MobileView() : DataTable()}
                    </Box>
                }
            </ScaleFade >
            {
                JobID !== "all" && <ScaleFade key={JobID} initialScale={0.9} in={JobID !== "all"} >
                    <JobInfoPage />
                </ScaleFade>
            }
        </>
    )
}
